// 82j / 83 §5 — THE TWO GLYPHS THAT SAY WHAT WILL BE ASKED OF YOU.
//
// Extracted from `AuthStepModal.tsx` unchanged so the SIGN-IN SCREEN and the
// SETTINGS PANEL show the same marks for the same thing — 83's glance: "give the
// passkey rows the same glyphs the sign-in screen uses". A person who has met
// the face and the fingerprint on the way in should meet them again where they
// choose to set one up.
//
// DELIBERATELY GENERIC, AND NOT ANY VENDOR'S MARK. Apple's Face ID and Touch ID
// marks are trademarks with their own usage rules, and this is a Belgian
// practice-management system that runs on Windows, Android and Linux as well.
// So: a plain face outline, and plain concentric fingerprint arcs — the shapes
// the whole industry uses, owned by nobody. `currentColor` throughout, so they
// inherit their container's colour and cannot fall foul of §4.9's
// no-hardcoded-colours rule.
//
// Module scope, not inside a render body: a PascalCase function declared inside
// a function and mounted as JSX is Bug-A, and `scripts/lint-inline-components.js`
// fails CI on exactly that shape.

export const FaceGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="9" />
    <circle cx="9" cy="10" r="0.6" fill="currentColor" stroke="none" />
    <circle cx="15" cy="10" r="0.6" fill="currentColor" stroke="none" />
    <path d="M8.5 14.5c1 1.1 2.2 1.6 3.5 1.6s2.5-.5 3.5-1.6" />
  </svg>
);

export const FingerprintGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.6" strokeLinecap="round" aria-hidden="true">
    <path d="M12 5.5c-3.6 0-6.5 2.9-6.5 6.5v2.2" />
    <path d="M18.5 12c0-3.6-2.9-6.5-6.5-6.5" />
    <path d="M12 9c-1.7 0-3 1.3-3 3v3.5" />
    <path d="M15 12c0-1.7-1.3-3-3-3" />
    <path d="M12 12.4v3.2" />
    <path d="M18.4 15.2a19 19 0 0 1-.5 3.3" />
    <path d="M6.1 17.6c.3-.9.4-1.8.4-2.7" />
  </svg>
);
